import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { AnonymousGuard } from './core/services/auth/anonymous.guard';
import { PostLandingLayoutComponent } from './layouts/post-landing-layout/post-landing-layout.component';
import { Error404Component } from './modules/errors-area/error-404/error-404.component';
import { AuthGuard } from './core/services/auth/auth.guard';

const routes: Routes = [
  // {
  //   path: 'shell',
  //   component: AppShellComponent,
  // },

  {
    path: 'contact-us',
    data: {
      pageInfoSEOKey: 'contactUs',
    },
    loadChildren: () =>
      import('./modules/landing-area/contact-us/contact-us.module').then(
        (c) => c.ContactUsModule,
      ),
  },


  {
    path: 'whatsapp-message-link-generator',
    data: {
      pageInfoSEOKey: 'whatsAppMessageLinkGenerator',
      fqaKey: 'whatsAppMessageLinkGenerator',
    },
    loadChildren: () =>
      import(
        './modules/tools-area/whatsapp-message-link-generator/whatsapp-message-link-generator.module'
      ).then((x) => x.WhatsAppMessageLinkGeneratorModule),
  },
  {
    path: 'crop-photo',
    data: {
      pageInfoSEOKey: 'cropPhoto',
      fqaKey: 'cropPhoto',
    },
    loadChildren: () =>
      import('./modules/tools-area/crop-photo/crop-photo.module').then(
        (x) => x.CropPhotoModule,
      ),
  },

  {
    path: 'post',

    loadChildren: () =>
      import('./modules/landing-area/post-landing/post-landing.module').then(
        (x) => x.PostLandingModule,
      ),
  },

  {
    path: 'qr-code-template-creator',
    data: {
      pageInfoSEOKey: 'qrCodeTemplateCreator',
      dashboardInfoKey: 'qrCodeTemplateCreator',
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './modules/tools-area/qr-code-template-creator/qr-code-template-creator.module'
      ).then((x) => x.QrCodeTemplateCreatorModule),
  },
  {
    path: '404',
    component: Error404Component,
    data: {
      pageInfoSEOKey: 'error404',
    },
  },
  {
    path: '',
    data: {
      pageInfoSEOKey: 'posty5',
    },
    loadChildren: () =>
      import('./modules/landing-area/home-page/home-page.module').then(
        (x) => x.HomePageModule,
      ),
  },
  {
    path: '',
    canActivate: [AnonymousGuard],

    loadChildren: () =>
      import('./modules/identity-area/auth/auth.module').then(
        (x) => x.AuthModule,
      ),
  },
  {
    path: '',

    loadChildren: () =>
      import('./modules/landing-area/contract/contract.module').then(
        (x) => x.ContractModule,
      ),
  },

  //Landing Short URL
  // {
  //   component: PostLandingLayoutComponent,

  //   matcher: (segments: UrlSegment[]) => {
  //     if (
  //       segments.length === 1 &&
  //       (segments[0].path.startsWith('_') || segments[0].path.startsWith('qr_'))
  //     ) {
  //       return {
  //         consumed: segments,
  //         posParams: {
  //           id: new UrlSegment(segments[0].path, {}),
  //           isQrCode: new UrlSegment(
  //             segments[0].path.startsWith('qr_') as any,
  //             {},
  //           ),
  //         },
  //       };
  //     }

  //     return null;
  //   },

  //   loadChildren: () =>
  //     import('./modules/landing-area/post-landing/post-landing.module').then(
  //       (c) => c.PostLandingModule,
  //     ),
  // },
];

const urlGroups = [
  {
    paths: [
      {
        path: 'url-shortener',
        data: {
          pageInfoSEOKey: 'urlShortener',
          fqaKey: 'urlShortener',
          dashboardInfoKey: 'urlShortener',
        },
      },
      {
        path: 'earn-money-with-short-urls',
        data: {
          pageInfoSEOKey: 'urlShortenerMonetize',
          fqaKey: 'urlShortener',
          dashboardInfoKey: 'urlShortener',
        },
      },
    ],
    loadChildren: () =>
      import('./modules/tools-area/url-shortener/url-shortener.module').then(
        (x) => x.URLShortenerModule,
      ),
  },

  {
    paths: [
      {
        path: 'qr-code-generator',
        data: {
          pageInfoSEOKey: 'qrCodeGenerator',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
        },
      },
      {
        path: 'earn-money-with-qr-code-generator',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorMonetize',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
        },
      },
      {
        path: 'qr-code-generator/call',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorCall',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'call',
        },
      },
      {
        path: 'qr-code-generator/contact',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorContact',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'contact',
        },
      },
      {
        path: 'qr-code-generator/wifi',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorWifi',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'wifi',
        },
      },
      {
        path: 'qr-code-generator/sms',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorSMS',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'sms',
        },
      },
      {
        path: 'qr-code-generator/url',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorURL',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'url',
        },
      },
      {
        path: 'qr-code-generator/geolocation',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorGeolocation',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'geolocation',
        },
      },
      {
        path: 'qr-code-generator/email',
        data: {
          pageInfoSEOKey: 'qrCodeGeneratorEmail',
          fqaKey: 'qrCodeGenerator',
          dashboardInfoKey: 'qrCodeGenerator',
          qrType: 'email',
        },
      },
    ],
    loadChildren: () =>
      import(
        './modules/tools-area/qr-code-generator/qr-code-generator.module'
      ).then((x) => x.QrCodeGeneratorModule),
  },

  {
    paths: [
      {
        path: 'static-hosting',
        data: {
          pageInfoSEOKey: 'staticHosting',
          fqaKey: 'htmlHosting',
          dashboardInfoKey: 'htmlHosting',
        },
      },
      {
        path: 'html-hosting',
        data: {
          pageInfoSEOKey: 'htmlHosting',
          fqaKey: 'htmlHosting',
          dashboardInfoKey: 'htmlHosting',
        },
      },
      {
        path: 'landing-page-hosting',
        data: {
          pageInfoSEOKey: 'landingPageHosting',
          fqaKey: 'htmlHosting',
          dashboardInfoKey: 'htmlHosting',
        },
      },
      {
        path: 'web-page-hosting',
        data: {
          pageInfoSEOKey: 'webPageHosting',
          fqaKey: 'htmlHosting',
          dashboardInfoKey: 'htmlHosting',
        },
      },
      {
        path: 'product-page-hosting',
        data: {
          pageInfoSEOKey: 'productPageHosting',
          fqaKey: 'htmlHosting',
          dashboardInfoKey: 'htmlHosting',
        },
      },
    ],
    loadChildren: () =>
      import('./modules/tools-area/html-hosting/html-hosting.module').then(
        (x) => x.HtmlHostingModule,
      ),
  },

  {
    paths: [
      {
        path: 'seo-tags-extractor',
        data: {
          pageInfoSEOKey: 'seoTagsExtractor',
          fqaKey: 'seoTagsExtractor',
        },
      },
      {
        path: 'youtube-tag-extractor',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube6',
          fqaKey: 'seoTagsExtractor',
        },
      },
      {
        path: 'extract-youtube-tags-titles-descriptions',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube5',
          fqaKey: 'seoTagsExtractor',
        },
      },
      {
        path: 'copy-youtube-tags-description',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube4',
          fqaKey: 'seoTagsExtractor',
        },
      },
      {
        path: 'youtube-seo-metadata-extractor',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube3',
          fqaKey: 'seoTagsExtractor',
        },
      }
      ,
      {
        path: 'youtube-tag-viewer-description-copier',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube2',
          fqaKey: 'seoTagsExtractor',
        },
      },
      {
        path: 'how-to-extract-youtube-tags-descriptions',
        data: {
          pageInfoSEOKey: 'seoTagsExtractorYouTube1',
          fqaKey: 'seoTagsExtractor',
        },
      },
    ],

    loadChildren: () =>
      import(
        './modules/tools-area/seo-tags-extractor/seo-tags-extractor.module'
      ).then((x) => x.SeoAnalyzerModule),


  }
];
for (const group of urlGroups) {
  for (const path of group.paths) {
    routes.push({
      path: path.path,
      data: path.data,
      loadChildren: group.loadChildren,
    });
  }
}
export function qrMatcher(url: UrlSegment[]): UrlMatchResult | null {
  // if (url.length > 0 && url[0].path.startsWith('qr_')) {
  //   return { consumed: url }; // تم تطابق المسار
  // }
  return null; // لا يوجد تطابق
}

export const langRoutes: Routes = [
  { path: 'ur', children: routes },
  { path: 'ar', children: routes },
  { path: 'en', children: routes },
  { path: 'hi', children: routes },
  { path: 'zh', children: routes },
  { path: 'es', children: routes },
  { path: 'bn', children: routes },
  { path: 'pt', children: routes },
  { path: 'ru', children: routes },
  { path: 'fr', children: routes },
  { path: '', children: routes },

  {
    path: '**',
    // matcher: (segments: UrlSegment[]) => {
    //   if (
    //     segments.length === 1 &&
    //     (segments[0].path.startsWith('_') || segments[0].path.startsWith('qr_'))
    //   ) {
    //     return {
    //       consumed: segments,
    //       posParams: {
    //         id: new UrlSegment(segments[0].path, {}),
    //         isQrCode: new UrlSegment(
    //           segments[0].path.startsWith('qr_') as any,
    //           {},
    //         ),
    //       },
    //     };
    //   }

    //   return null;
    // },
    component: PostLandingLayoutComponent,
    // resolve: { lang: LanguageResolver },
    loadChildren: () =>
      import('./modules/landing-area/post-landing/post-landing.module').then(
        (c) => c.PostLandingModule,
      ),
  },
  // { path: '**', resolve: { lang: LanguageResolver }, children: routes },
];
